export default function Progress({ step }) {
  const pct = step === 0 ? 0 : step === 7 ? 100 : Math.round((step / 7) * 100);
  const label =
    step === 0
      ? "Tu tarifa te espera"
      : step === 6
        ? "Ya casi ves tu número"
        : step === 7
          ? "Listo"
          : `Pregunta ${step} de 6`;

  return (
    <div className="progress" data-testid="progress-bar" aria-label={`${label} · ${pct}%`}>
      <div className="progress-row">
        <span className="progress-label" data-testid="progress-label">
          {label}
        </span>
        <span className="progress-num" data-testid="progress-num">
          {pct}%
        </span>
      </div>
      <div className="progress-track" aria-hidden="true">
        <div className="progress-fill" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
